import { render } from "./FormularioFormularioAvaliacao.vue?vue&type=template&id=37c47751&scoped=true"
import script from "./FormularioFormularioAvaliacao.vue?vue&type=script&lang=js"
export * from "./FormularioFormularioAvaliacao.vue?vue&type=script&lang=js"

import "./FormularioFormularioAvaliacao.vue?vue&type=style&index=0&id=37c47751&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c47751"]])

export default __exports__